/* eslint-disable no-case-declarations */
import {
  SET_ADD_FAVORITES, ADD_FAVORITES_REQUEST_FAILED, SENDING_ADD_FAVORITES_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  aFData: '',
  isAFSending: false,
  afError: false,
  isAFSuccess: false,
};

/**
    * dispatched the user data to the store
    * @param  { Object } state  default state
    * @param  { Object } action dispacthed action from middleware
    */
export default function addFavorites(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_ADD_FAVORITES:
      const data = {};
      data.aFData = action.aFData;
      data.isAFSending = action.isAFSending;
      data.isAFSuccess = action.isAFSuccess;
      data.afError = action.afError;
      return { ...state, ...data };

    case SENDING_ADD_FAVORITES_REQUEST:
      const sendingRequest = {};
      sendingRequest.aFData = action.aFData;
      sendingRequest.isAFSending = action.isAFSending;
      sendingRequest.isAFSuccess = action.isAFSuccess;
      sendingRequest.afError = action.afError;
      return { ...state, ...sendingRequest };

    case ADD_FAVORITES_REQUEST_FAILED:
      const errors = {};
      errors.aFData = action.aFData;
      errors.isAFSending = action.isAFSending;
      errors.isAFSuccess = action.isAFSuccess;
      errors.afError = action.afError;
      errors.fMsg = action.fMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
